'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIBreakString from 'UIComponents/text/UIBreakString';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import withConnectedFolder from 'DesignFinderUI/hocs/withConnectedFolder';

const i18nKey = key => `DesignFinderUI.modals.RenameFolderConfirmModal.${key}`;

class RenameFolderConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleConfirmChange = this.handleConfirmChange.bind(this);
    this.handleDimissChange = this.handleDimissChange.bind(this);
    this.state = {
      confirmed: false,
      dismiss: false
    };
  }

  handleCancel() {
    const {
      callback,
      toggleRenameFolder
    } = this.props;
    toggleRenameFolder();
    callback(false);
  }

  handleConfirm() {
    const {
      callback,
      hideRenameConfirm,
      newFolderName,
      renameFolder,
      toggleRenameFolder
    } = this.props;

    if (this.state.dismiss) {
      hideRenameConfirm();
    }

    toggleRenameFolder();
    renameFolder(newFolderName);
    callback(true);
  }

  handleConfirmChange(evt) {
    this.setState({
      confirmed: evt.target.checked
    });
  }

  handleDimissChange(evt) {
    this.setState({
      dismiss: evt.target.checked
    });
  }

  render() {
    const {
      folderName,
      newFolderName
    } = this.props;
    const {
      confirmed,
      dismiss
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModal, {
      size: "auto",
      use: "danger",
      width: 610,
      "data-test-id": "rename-folder-modal",
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(UIBreakString, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('header.text'),
              options: {
                folderName: I18n.SafeString(folderName),
                newFolderName: I18n.SafeString(newFolderName)
              }
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(UIBreakString, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('warning.text'),
              options: {
                newFolderName
              }
            })
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "m-bottom-6",
          children: [/*#__PURE__*/_jsx(UICheckbox, {
            checked: confirmed,
            "data-test-id": "modal__rename-folder__confirm-checkbox",
            onChange: this.handleConfirmChange,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('checkboxes.confirm.label')
            })
          }), /*#__PURE__*/_jsx(UICheckbox, {
            checked: dismiss,
            disabled: !confirmed,
            onChange: this.handleDimissChange,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('checkboxes.dismiss.label')
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "has--horizontal-spacing m-left-0",
          children: [/*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "modal__rename-folder__rename-button",
            disabled: !confirmed,
            onClick: this.handleConfirm,
            use: "danger",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('buttons.confirm.text')
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: this.handleCancel,
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('buttons.cancel.text')
            })
          })]
        })]
      })]
    });
  }

}

RenameFolderConfirmModal.propTypes = {
  callback: PropTypes.func,
  folderName: FolderPropTypes.folderName.isRequired,
  hideRenameConfirm: PropTypes.func.isRequired,
  newFolderName: FolderPropTypes.folderName.isRequired,
  renameFolder: PropTypes.func.isRequired,
  toggleRenameFolder: PropTypes.func.isRequired
};
RenameFolderConfirmModal.defaultProps = {
  callback: emptyFunction
};
export default withConnectedFolder(RenameFolderConfirmModal);